// Gabybru Analytics: conservar los eventos de tallas del tema anterior en Dawn 16.
(() => {
  if (window.gabybruVariantTrackingReady) return;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  window.gabybruVariantTrackingReady = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
    const variant = data?.variant;
    if (!variant || typeof variant.available !== 'boolean') return;

    const section = document.getElementById('MainProduct-' + data.sectionId);
    if (!section) return;

    const payload = {
      product_path: section.dataset.url || window.location.pathname,
      variant_id: String(variant.id),
      sku: variant.sku || '',
      variant_title: variant.title || '',
      selected_options: Array.isArray(variant.options) ? [...variant.options] : [],
      available: variant.available,
      price: variant.price != null ? Number(variant.price) / 100 : null,
      compare_at_price: variant.compare_at_price != null ? Number(variant.compare_at_price) / 100 : null,
      currency: 'CLP',
    };

    const eventName = variant.available ? 'gbr_variant_in_stock' : 'gabybru_out_of_stock_variant';
    try {
      const result = window.Shopify?.analytics?.publish(eventName, payload);
      if (result && typeof result.catch === 'function') {
        result.catch((error) => console.warn('Gabybru: no se pudo registrar la talla', error));
      }
    } catch (error) {
      console.warn('Gabybru: no se pudo registrar la talla', error);
    }
  });
})();
